export default "<h3>Billing Settings</h3>\n<app-api-gateway-settings></app-api-gateway-settings>\n\n"